export default __webpack_public_path__ + "static/media/alur ASA.8660246c.png";